(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(59697);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 18707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context_global_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72265);



var Settings = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context_global_context__WEBPACK_IMPORTED_MODULE_2__/* .GlobalContext */ .k), theme = ref.theme, setTheme = ref.setTheme;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(theme === "light" ? false : true), isChecked = ref1[0], setIsChecked = ref1[1];
    var handleChange = function() {
        return setIsChecked(!isChecked);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var theme = localStorage.getItem("continia.theme");
        if (theme) {
            setIsChecked(theme === "dark");
            setTheme(theme === "dark" ? "dark" : "light");
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        localStorage.setItem("continia.theme", isChecked ? "dark" : "light");
        setTheme(isChecked ? "dark" : "light");
    }, [
        isChecked,
        setTheme
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex justify-end align-center items-center ",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "h-20 flex justify-end align-center items-center mr-2"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Settings);


/***/ }),

/***/ 59697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Home": function() { return /* binding */ Home; },
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@azure/msal-react/dist/msal-react.esm.js + 2 modules
var msal_react_esm = __webpack_require__(14471);
// EXTERNAL MODULE: ./layouts/landing-page-new-design.tsx + 2 modules
var landing_page_new_design = __webpack_require__(94027);
// EXTERNAL MODULE: ./utils/user.ts
var user = __webpack_require__(49509);
// EXTERNAL MODULE: ./apiFrontend/bookmarksApi.ts
var bookmarksApi = __webpack_require__(51341);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(41248);
// EXTERNAL MODULE: ./utils/i18n.ts + 3 modules
var i18n = __webpack_require__(87161);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(57632);
// EXTERNAL MODULE: ./node_modules/algoliasearch/dist/algoliasearch-lite.umd.js
var algoliasearch_lite_umd = __webpack_require__(70290);
var algoliasearch_lite_umd_default = /*#__PURE__*/__webpack_require__.n(algoliasearch_lite_umd);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-core/dist/es/components/InstantSearch.js + 35 modules
var InstantSearch = __webpack_require__(45870);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-core/dist/es/components/Configure.js + 2 modules
var Configure = __webpack_require__(58685);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./components-aria/header.tsx + 4 modules
var header = __webpack_require__(803);
// EXTERNAL MODULE: ./components-aria/search-bar.tsx
var search_bar = __webpack_require__(22904);
// EXTERNAL MODULE: ./node_modules/@madebyconnor/rich-text-to-jsx/dist/index.js
var dist = __webpack_require__(19236);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
;// CONCATENATED MODULE: ./components-aria/hero.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 47.2vw;\n  width: 100%;\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  max-width: 620px;\n  margin-left: 280px;\n  padding-top: 200px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  h1 {\n    font-family: 'alliance_no.2bold';\n    font-weight: 700;\n    font-size: 85px;\n    line-height: 80px;\n  }\n\n  h6 {\n    font-family: 'Alliance No.2';\n    font-weight: 400;\n    font-size: 24px;\n    line-height: 70px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: -5px;\n  right: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}












var searchClient = algoliasearch_lite_umd_default()("OKQOY8CWEO", "977bba8b058c6a2c7d94982e64a9f24b");
var LanguageTypes;
(function(LanguageTypes) {
    LanguageTypes["da"] = "da-dk";
    LanguageTypes["de"] = "de-de";
    LanguageTypes["en-us"] = "en-us";
})(LanguageTypes || (LanguageTypes = {}));
var LandingHero = function(param) {
    var title = param.title, text = param.text;
    var locale = (0,router.useRouter)().locale;
    var solutions = i18n/* default */.Z[locale || "en-US"].solutions;
    var keys = (0,react.useMemo)(function() {
        return solutions.map(function() {
            return (0,v4/* default */.Z)();
        });
    }, [
        solutions
    ]);
    var ref = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            products: []
        }
    }), register = ref.register, handleSubmit = ref.handleSubmit, watch = ref.watch, control = ref.control, setValue = ref.setValue;
    var selectedProducts = watch("products", []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSection, {
        style: {
            backgroundImage: "url('/images/hero.jpg')"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSearchContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTextContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                                    richText: text.json
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InstantSearch/* InstantSearch */.p, {
                        searchClient: searchClient,
                        indexName: "continia.portal-test",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Configure/* Configure */.T, {
                                hitsPerPage: 7,
                                optionalFilters: [
                                    "language.name:".concat(locale)
                                ],
                                facetFilters: [
                                    selectedProducts ? selectedProducts === null || selectedProducts === void 0 ? void 0 : selectedProducts.map(function(product) {
                                        return "product.value:".concat(product);
                                    }) : ""
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(search_bar/* default */.Z, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSvgContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    width: "298",
                    height: "321",
                    viewBox: "0 0 298 321",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M298 321V0.936523C298 83.227 231.29 149.937 149 149.937V321H298Z",
                            fill: "#F5EDDA",
                            fillOpacity: "0.7"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M0 298.936C0 216.646 66.7096 149.936 149 149.936V320.999H0V298.936Z",
                            fill: "#F5EDDA",
                            fillOpacity: "0.7"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSvgContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    width: "299",
                    height: "256",
                    viewBox: "0 0 299 256",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M149.5 255.457H299V0.899414C299 71.1937 242.015 128.178 171.721 128.178H149.5V255.457Z",
                            fill: "#F5EDDA"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M0 255.457C0 185.162 56.9848 128.178 127.279 128.178H149.5V255.457H0Z",
                            fill: "#F5EDDA"
                        })
                    ]
                })
            })
        ]
    });
};
var StyledSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-8bcbf8fd-0"
})(_templateObject());
var StyledSearchContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8bcbf8fd-1"
})(_templateObject1());
var StyledTextContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8bcbf8fd-2"
})(_templateObject2());
var StyledSvgContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8bcbf8fd-3"
})(_templateObject3());
/* harmony default export */ var hero = (LandingHero);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components-aria/testimonial-section.tsx

function testimonial_section_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1350px;\n  display: flex;\n  justify-content: space-between;\n  margin: 0 auto;\n  column-gap: 200px;\n"
    ]);
    testimonial_section_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function testimonial_section_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: ",
        ";\n  padding: 40px;\n  padding: 200px 0;\n"
    ]);
    testimonial_section_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function testimonial_section_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 50%;\n  font-size: 1.2rem;\n  line-height: 1.6;\n  max-width: 564px;\n  padding-top: 100px;\n\n  blockquote {\n    font-size: 1.5rem;\n    font-family: 'alliance_no.2bold';\n    font-weight: 700;\n    font-size: 28px;\n    line-height: 37px;\n  }\n\n  p {\n    margin-top: 40px;\n    font-family: 'Alliance No.2';\n    font-weight: 300;\n    font-size: 20px;\n    line-height: 20px;\n  }\n"
    ]);
    testimonial_section_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function testimonial_section_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 40%;\n  position: relative;\n  border-radius: 12px;\n  overflow: hidden;\n  width: 586px;\n  height: 586px;\n  width: 586px;\n\n  img {\n    border-radius: 100px 10px 100px 10px;\n  }\n"
    ]);
    testimonial_section_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var TestimonialSection = function(param) {
    var bgColor = param.bgColor, imageUrl = param.imageUrl, quoteText = param.quoteText, author = param.author, imageAlt = param.imageAlt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionContainer, {
        bgColor: bgColor,
        "aria-label": "Testimonial Section",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextBlock, {
                    "aria-label": "Testimonial Text",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", {
                            children: quoteText
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: author
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageBlock, {
                    "aria-label": "Person Image",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: imageUrl,
                        alt: imageAlt,
                        layout: "fill",
                        objectFit: "cover",
                        quality: 100
                    })
                })
            ]
        })
    });
};
var ContentContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-864ddf7e-0"
})(testimonial_section_templateObject());
var SectionContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-864ddf7e-1"
})(testimonial_section_templateObject1(), function(props) {
    return props.bgColor || "#fff";
});
var TextBlock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-864ddf7e-2"
})(testimonial_section_templateObject2());
var ImageBlock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-864ddf7e-3"
})(testimonial_section_templateObject3());
/* harmony default export */ var testimonial_section = (TestimonialSection);

;// CONCATENATED MODULE: ./components-aria/feature-section.tsx

function feature_section_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1350px;\n  display: flex;\n  justify-content: space-between;\n  margin: 0 auto;\n  column-gap: 200px;\n  background-image: url('/wave.png'); /* Path to the wave.png in the public folder */\n  background-repeat: no-repeat;\n  background-position: center top; /* Adjust as needed */\n  background-size: cover; /* Ensure the image covers the container */\n"
    ]);
    feature_section_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function feature_section_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: ",
        ";\n  padding: 40px;\n  padding: 200px 0;\n"
    ]);
    feature_section_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function feature_section_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 50%;\n  font-size: 1.2rem;\n  line-height: 1.6;\n  max-width: 564px;\n  padding-top: 40px;\n\n  h2 {\n    font-size: 1.5rem;\n    font-family: 'alliance_no.2bold';\n    font-weight: 700;\n    font-size: 60px;\n    line-height: 79.2px;\n  }\n\n  p {\n    margin: 40px 0;\n    font-family: 'Alliance No.2';\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 19px;\n    max-width: 450px;\n\n    span {\n      font-family: 'alliance_no.2bold';\n    }\n  }\n"
    ]);
    feature_section_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function feature_section_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 40%;\n  position: relative;\n  border-radius: 12px;\n  overflow: hidden;\n  width: 586px;\n  height: 586px;\n  width: 586px;\n\n  img {\n    border-radius: 100px 10px 100px 10px;\n  }\n"
    ]);
    feature_section_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: calc(100% / 2 - 10px);\n  position: relative;\n\n  a {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: #fff;\n    padding: 15px 20px;\n    font-size: 18px;\n    font-weight: 600;\n    color: #052975;\n    text-decoration: none;\n    border-radius: 5px;\n    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1);\n\n    span {\n      font-size: 24px;\n    }\n\n    &:hover {\n      box-shadow: 4px 8px 8px 0px rgba(0, 0, 0, 0.5);\n      transition: box-shadow 0.3s ease-in;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 33px;\n  height: 33px;\n  border-radius: 50%;\n  background-color: #052975;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: background-color 0.3s ease;\n  position: absolute;\n  right: 13px;\n  top: 50%;\n  transform: translateY(-50%);\n\n  /* &:hover {\n    background-color: #0056b3;\n  } */\n\n  svg {\n    width: 9px;\n    height: 15px;\n    margin-left: 2px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var FeatureSection = function(param) {
    var bgColor = param.bgColor, imageUrl = param.imageUrl, title = param.title, description = param.description, imageAlt = param.imageAlt, links = param.links;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(feature_section_SectionContainer, {
        bgColor: bgColor,
        "aria-label": "Feature Section",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(feature_section_ContentContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(feature_section_ImageBlock, {
                    "aria-label": "Feature Image",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: imageUrl,
                        alt: imageAlt,
                        layout: "fill",
                        objectFit: "cover",
                        quality: 100
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(feature_section_TextBlock, {
                    "aria-label": "Feature Text",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "Submit your ideas for new features, suggest improvements to the existing ones, or view, vote or comment on other peoples ideas to promote these for ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "future implementation."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkList, {
                            children: links.map(function(link, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkItem, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: link.href,
                                            children: link.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleArrow, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                width: "9",
                                                height: "15",
                                                viewBox: "0 0 9 15",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M8.25666 6.74347C8.67504 7.16185 8.67504 7.84131 8.25666 8.2597L1.83024 14.6861C1.41185 15.1045 0.73239 15.1045 0.314004 14.6861C-0.104383 14.2677 -0.104383 13.5883 0.314004 13.1699L5.98398 7.49991L0.317016 1.82993C-0.101371 1.41155 -0.101371 0.732421 0.317016 0.314034C0.735403 -0.104353 1.41486 -0.104353 1.83325 0.314034L8.25967 6.74045L8.25632 6.7438L8.25666 6.74347Z",
                                                    fill: "white"
                                                })
                                            })
                                        })
                                    ]
                                }, index);
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var feature_section_ContentContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-c02a5d05-0"
})(feature_section_templateObject());
var feature_section_SectionContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-c02a5d05-1"
})(feature_section_templateObject1(), function(props) {
    return props.bgColor || "#fff";
});
var feature_section_TextBlock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c02a5d05-2"
})(feature_section_templateObject2());
var feature_section_ImageBlock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c02a5d05-3"
})(feature_section_templateObject3());
var LinkList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-c02a5d05-4"
})(_templateObject4());
var LinkItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-c02a5d05-5"
})(_templateObject5());
var CircleArrow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c02a5d05-6"
})(_templateObject6());
/* harmony default export */ var feature_section = (FeatureSection);

;// CONCATENATED MODULE: ./components-aria/solutions-section.tsx

function solutions_section_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1350px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 0 auto;\n  column-gap: 200px;\n"
    ]);
    solutions_section_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function solutions_section_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: space-between;\n  align-items: center;\n  background-color: #fffdf8;\n  padding: 85px 40px 100px;\n  background-image: url('/images/wave-bg.png');\n  background-repeat: no-repeat;\n  background-position: center top;\n  background-size: cover;\n"
    ]);
    solutions_section_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function solutions_section_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 50%;\n  font-size: 1.2rem;\n  line-height: 1.6;\n  max-width: 645px;\n\n  h2 {\n    font-size: 1.5rem;\n    font-family: 'alliance_no.2bold';\n    font-weight: 700;\n    font-size: 60px;\n    line-height: 79.2px;\n    text-align: center;\n    margin: 0 0 24px 0;\n  }\n\n  p {\n    margin: 40px 0;\n    font-family: 'Alliance No.2';\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 19px;\n    text-align: center;\n    margin-top: 0px;\n\n    span {\n      font-family: 'alliance_no.2bold';\n    }\n  }\n"
    ]);
    solutions_section_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function solutions_section_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: 40px;\n  justify-content: center;\n"
    ]);
    solutions_section_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function solutions_section_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n  border-radius: 50px 1px 50px 1px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  align-items: center;\n  padding: 40px 36px 44px 36px;\n  width: 423px;\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\n  cursor: pointer;\n  transition: all 0.3s ease-in;\n\n  &:hover {\n    filter: drop-shadow(4px 8px 8px rgba(0, 0, 0, 0.5));\n    transition: all 0.3s ease-in;\n    transform: scale(1.02);\n    cursor: pointer;\n    background-color: ",
        ";\n  }\n\n  svg {\n    margin-right: 10px;\n  }\n\n  a {\n    font-family: 'Alliance No.2';\n    font-size: 1.2rem;\n    color: #333;\n    text-decoration: none;\n  }\n"
    ]);
    solutions_section_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var hoverColor;
(function(hoverColor) {
    hoverColor["Pale Navy"] = "#CBD0DA";
    hoverColor["Dark Moderate Blue"] = "#2A457E";
    hoverColor["White Smoke"] = "#E7EAF1";
})(hoverColor || (hoverColor = {}));
var textColor;
(function(textColor) {
    textColor["Pale Navy"] = "#262626";
    textColor["Dark Moderate Blue"] = "#fff";
    textColor["White Smoke"] = "#262626";
})(textColor || (textColor = {}));
var SolutionsSection = function(param) {
    var title = param.title, description = param.description, solutions = param.solutions;
    console.log("solutions", solutions);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(solutions_section_SectionContainer, {
        "aria-label": "Solutions Section",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(solutions_section_ContentContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(solutions_section_TextBlock, {
                    "aria-label": "Solutions Text",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                            richText: description.json
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemsList, {
                    "aria-label": "Items List",
                    children: solutions.items.map(function(solution) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                            color: solution.backgroundColor.value,
                            textColor: textColor[solution.backgroundColor.name],
                            hoverColor: hoverColor[solution.backgroundColor.name],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: solution.logo.url,
                                    alt: solution.logo.title,
                                    layout: "intrinsic",
                                    width: solution.logo.width,
                                    height: solution.logo.height
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                                    richText: solution.description.json
                                })
                            ]
                        }, solution.sys.id);
                    })
                })
            ]
        })
    });
};
var solutions_section_ContentContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-34128b3c-0"
})(solutions_section_templateObject());
var solutions_section_SectionContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-34128b3c-1"
})(solutions_section_templateObject1());
var solutions_section_TextBlock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-34128b3c-2"
})(solutions_section_templateObject2());
var ItemsList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-34128b3c-3"
})(solutions_section_templateObject3());
var Item = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-34128b3c-4"
})(solutions_section_templateObject4(), function(param) {
    var color = param.color;
    return color;
}, function(param) {
    var textColor = param.textColor;
    return textColor;
}, function(param) {
    var hoverColor = param.hoverColor;
    return hoverColor;
});
/* harmony default export */ var solutions_section = (SolutionsSection);

// EXTERNAL MODULE: ./components-aria/profile-section.tsx
var profile_section = __webpack_require__(12405);
// EXTERNAL MODULE: ./components-aria/sign-in-section.tsx
var sign_in_section = __webpack_require__(52490);
;// CONCATENATED MODULE: ./pages/index.tsx




// import LandingOverview from '../components/tailwind-m/landing-overview';












var __N_SSG = true;
var Home = function(param) {
    var frontpage = param.frontpage, newUpdatedRecently = param.newUpdatedRecently, landingPage = param.landingPage;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,router.useRouter)(), locale = ref4.locale, push = ref4.push;
    var dispatch = (0,es/* useDispatch */.I0)();
    var isAuthenticated = (0,msal_react_esm/* useIsAuthenticated */.kq)();
    var ref5 = (0,user/* useUserData */.v$)(), accounts = ref5.accounts, accessToken = ref5.accessToken;
    var account = accounts[0];
    var quickLinks = i18n/* default */.Z[locale || "en-US"].quickLinks;
    var ref6 = bookmarksApi/* default.useGetBookmarksQuery */.Z.useGetBookmarksQuery(null, {
        skip: !isAuthenticated || !accessToken
    }), bookmarksData = ref6.data, bookmarksRefetch = ref6.refetch;
    (0,react.useEffect)(function() {
        if (isAuthenticated && accessToken) {
            bookmarksRefetch();
        }
        return function() {
            dispatch(bookmarksApi/* default.util.invalidateTags */.Z.util.invalidateTags([
                "all-bookmarks"
            ]));
        };
    }, [
        isAuthenticated,
        accessToken,
        bookmarksRefetch,
        accounts,
        dispatch
    ]);
    var name = "".concat(((ref = account === null || account === void 0 ? void 0 : account.idTokenClaims) === null || ref === void 0 ? void 0 : ref.given_name) || "", " ").concat(((ref1 = account === null || account === void 0 ? void 0 : account.idTokenClaims) === null || ref1 === void 0 ? void 0 : ref1.family_name) || "").trim() || (account === null || account === void 0 ? void 0 : account.name) || ((ref2 = account === null || account === void 0 ? void 0 : account.idTokenClaims) === null || ref2 === void 0 ? void 0 : ref2.name) || ((ref3 = account === null || account === void 0 ? void 0 : account.idTokenClaims) === null || ref3 === void 0 ? void 0 : ref3.display_name) || (account === null || account === void 0 ? void 0 : account.username);
    console.log("landingPage", landingPage);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(landing_page_new_design/* default */.Z, {
        title: frontpage.meta.title,
        description: frontpage.meta.description,
        mainClassName: "new-design",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(hero, {
                title: landingPage.title,
                text: landingPage.heroText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(msal_react_esm/* AuthenticatedTemplate */.NY, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(profile_section/* default */.Z, {
                    bookmarks: bookmarksData
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(msal_react_esm/* UnauthenticatedTemplate */.ae, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sign_in_section/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(solutions_section, {
                title: landingPage.solutionsSectionTitle,
                description: landingPage.solutionsSectionText,
                solutions: landingPage.solutionsListCollection
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(feature_section, {
                bgColor: "#F5EDDA",
                imageUrl: "/images/ideas.png",
                imageAlt: "Feature image",
                title: "Share your ideas!",
                // description="Submit your ideas for new features, suggest improvements to the existing ones, or view, vote or comment on other people's ideas."
                links: quickLinks
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(testimonial_section, {
                bgColor: "#FFFDF8",
                imageUrl: "/images/testimonial.png",
                quoteText: "One thing I\u2019m still impressed about: we have 45 companies, and everything is sent to one email address. The system figures out where it needs to go. So, it\u2019s quite impressive.",
                author: "Monique Jacquem, CFO of Basecamp",
                imageAlt: "Monique Jacquem"
            })
        ]
    });
};
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 26956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var NonSSRWrapper = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(NonSSRWrapper);
}, {
    ssr: false
}));


/***/ }),

/***/ 44653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ utils_Portal; }
});

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./hooks/usePortal.ts

var createRootRef = function(visible) {
    var element = document.createElement("div");
    element.style.position = visible ? "unset" : "absolute";
    element.style.height = visible ? "auto" : "0px";
    element.style.overflow = visible ? "auto" : "hidden";
    return element;
};
var usePortal = function(id, visible) {
    var rootElemRef = (0,react.useRef)(createRootRef(visible));
    (0,react.useEffect)(function() {
        var modalRoot = document.getElementById(id);
        if (!modalRoot) {
            var containerDiv = document.createElement("div");
            containerDiv.id = id;
            document.documentElement.appendChild(containerDiv);
        }
    }, [
        id
    ]);
    (0,react.useEffect)(function() {
        var existingParent = document.getElementById(id);
        // existingParent.appendChild(rootElemRef.current);
        existingParent.replaceChildren(rootElemRef.current);
        return function removeElement() {
            rootElemRef.current.remove();
            if (!existingParent.childElementCount) {
                existingParent.remove();
            }
        };
    }, [
        id
    ]);
    return rootElemRef.current;
};
/* harmony default export */ var hooks_usePortal = (usePortal);

;// CONCATENATED MODULE: ./utils/Portal.tsx


var Portal = function(param) {
    var id = param.id, visible = param.visible, children = param.children;
    var target = hooks_usePortal(id, visible);
    if (!target) {
        return null;
    }
    return /*#__PURE__*/ (0,react_dom.createPortal)(children, target);
};
/* harmony default export */ var utils_Portal = (Portal);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2602,5675,4417,9236,5157,1480,7161,9375,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);